
import restService from "@/services/restService"
import { IPassengerSearchResult } from '@/typings/timit';
import { Vue, Watch, Component, Prop } from "vue-property-decorator";
import { Destination } from './Passenger/models/Destination';

@Component
export default class PassengerSearch extends Vue {
  loading: boolean = false;
  selectedPassenger: IPassengerSearchResult | null = null;
  search = "";
  searchDebounceTimeout: any = null;
  searchDebounceTimeoutDurationMs: number = 1500;

  passengers: IPassengerSearchResult[] = [];

  @Prop({ default: () => [] }) private excludedPassengerIds!: number[];

  @Prop({ default: () => {} }) private searchParams!: any;

  @Watch('search') async searchChanged() {
    // Search passengers
    if (this.search && this.search.length > 0) {
      await this.searchPassengers();
    }
  }

  async searchPassengers() {

    if (this.searchDebounceTimeout){
        clearTimeout(this.searchDebounceTimeout);
      }
    this.searchDebounceTimeout = setTimeout(
        async () => {
          if (this.search && this.search.length > 0) {
            const result: IPassengerSearchResult[] = await restService.passengers.searchPassengers(this.search, this.searchParams);
            const destinations: Destination[] = this.$store.state.destination.destinations;
            this.passengers = result
            .map(p => {
              const destination = destinations.find(d => d.id === p.destinationId);
              p.destinationName = destination && destination.alias ? destination.alias : '';
              p.movitInstanceName = destination && destination.movitInstanceName ? destination.movitInstanceName : '';
              return p;
            })
            .filter(p => !this.excludedPassengerIds.includes(p.id));
          }
        }, 
        this.searchDebounceTimeoutDurationMs
      )
  }

  selectPassenger(passengerSearchResult: IPassengerSearchResult) {
    this.$emit('passengerSelect', passengerSearchResult);
    this.selectedPassenger = null;
    this.search = '';
    this.passengers = [];
  }

}
